import { render, staticRenderFns } from "./ChooseLocale-2.vue?vue&type=template&id=aedf9d4e"
import script from "./ChooseLocale-2.vue?vue&type=script&lang=js"
export * from "./ChooseLocale-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports